import React from "react";

interface SectionTemplateHeaderProps {
  subTitle?: string | JSX.Element
}

export const SectionTemplateHeader = (props: React.PropsWithChildren<SectionTemplateHeaderProps>) => {
  return <div className="grow1">
    <div className="header-title">{props.children}</div>
    {props.subTitle && <div className="header-subTitle">{props.subTitle}</div>}
  </div>
}